import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { LuppTrack } from '@/types/lupp-track'

export function getTracks(): Promise<AxiosResponse<LuppTrack[]>> {
  return instance.get(`/lupp/track`)
}
